/* Copyright 2013 - 2024 Waiterio LLC */
import window from './window.js'

const macos =
  window?.navigator?.platform?.toLowerCase()?.indexOf('mac') >= 0 ?? false

export default macos
